<template>
  <t-dropdown
    class="relative w-full"
    :fixed-classes="{
      dropdown: 'w-full',
    }"
  >
    <div
      slot="trigger"
      slot-scope="{ mousedownHandler, blurHandler, keydownHandler }"
      class="relative w-full max-w-xs"
    >
      <button class="absolute left-3 top-1/2 transform -translate-y-1/2">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.7556 18.5783L14.0682 12.8908C15.1699 11.53 15.8332 9.80088 15.8332 7.91758C15.8332 3.55262 12.2815 0.000976562 7.91656 0.000976562C3.55161 0.000976562 0 3.55258 0 7.91754C0 12.2825 3.55165 15.8341 7.9166 15.8341C9.7999 15.8341 11.5291 15.1708 12.8899 14.0692L18.5773 19.7566C18.7398 19.9191 18.9531 20.0008 19.1665 20.0008C19.3798 20.0008 19.5932 19.9191 19.7557 19.7566C20.0815 19.4308 20.0815 18.9041 19.7556 18.5783ZM7.9166 14.1675C4.46996 14.1675 1.66666 11.3642 1.66666 7.91754C1.66666 4.47089 4.46996 1.6676 7.9166 1.6676C11.3632 1.6676 14.1665 4.47089 14.1665 7.91754C14.1665 11.3642 11.3632 14.1675 7.9166 14.1675Z"
            fill="#212022"
          />
        </svg>
      </button>
      <input
        v-if="false"
        class="
          text-base text-black-900
          rounded
          border border-grey-500
          pl-12
          pr-8
          py-2
          w-full
          focus:border-black-900
          outline-none
        "
        type="text"
        v-model="inputData"
        :placeholder="placeholder"
      />
      <div
        v-else
        class="
          rounded
          border border-grey-500
          pl-10
          pr-8
          py-2
          w-full
          flex
          items-center
        "
      >
        <span class="text-base text-black-900 max-w-175 line-clamp-1 mr-1"
          >A long publisher na... /
        </span>
        <span class="bg-black-900 text-white-900 text-base px-1 rounded-2xl"
          >+2</span
        >
      </div>
      <button
        class="absolute right-3 top-1/2 transform -translate-y-1/2"
        @click="toggleDropdown"
        @mousedown="mousedownHandler"
        @blur="blurHandler"
        @keydown="keydownHandler"
      >
        <svg
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1L5 5L9 1"
            stroke="#484749"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <ul
      class="
        absolute
        top-full
        mt-1
        py-1
        bg-white-900
        rounded
        shadow-xxs
        w-full
        z-10
      "
      slot-scope="{ blurHandler }"
    >
      <li
        v-for="(searchedItem, i) in searchedData"
        :key="i"
        class="flex justify-between px-2 py-1 bg-white hover:bg-grey-400"
        :class="{ 'bg-grey-400': searchedItem.selected }"
      >
        <label
          :for="'checkbox' + i"
          class="
            cursor-pointer
            flex-grow
            line-clamp-1
            pr-1
            text-base text-black-900
          "
        >
          {{ searchedItem.name }}
        </label>
        <input
          type="checkbox"
          v-model="searchedItem.selected"
          class="
            form-checkbox
            rounded-full
            text-orange-900
            shadow-disable
            w-5
            h-5
            cursor-pointer
            flex-shrink-0
          "
          :id="'checkbox' + i"
          @blur="blurHandler"
        />
      </li>
    </ul>

    <p
      v-if="false"
      class="
        absolute
        top-full
        mt-1
        py-6
        px-4
        text-center
        bg-white-900
        rounded
        shadow-xxs
        w-full
        text-base text-black-900
        z-10
      "
    >
      No results found
    </p>
  </t-dropdown>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      inputData: "",
      dropdownOpened: false,
      searchedData: [
        {
          name: "A long publisher name",
          selected: false,
        },
        {
          name: "B long publisher name",
          selected: false,
        },
        {
          name: "C long publisher name",
          selected: false,
        },
        {
          name: "D long publisher name",
          selected: false,
        },
        {
          name: "E long publisher name",
          selected: false,
        },
        {
          name: "Publisher name",
          selected: false,
        },
        {
          name: "Publisher name",
          selected: false,
        },
        {
          name: "Publisher name",
          selected: false,
        },
        {
          name: "Publisher name",
          selected: false,
        },
      ],
    };
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpened = !this.dropdownOpened;
    },
  },
  computed: {
    isEmpty() {
      return this.inputData.length <= 0;
    },
  },
};
</script>
